import { PageProps } from "gatsby";
import React, { useCallback, useEffect, useLayoutEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "@reach/router";

import "../../styles/globals.scss";
import { SiteContainer, useSiteContext } from "../SiteContext";
import { SEO } from "../SEO";
import { Header } from "../Header";

import * as styles from "./Layout.module.scss";
import { Navigation } from "../Navigation";
import { MenuIcon } from "../MenuIcon";
import * as Analytics from "../../utils/analytics";

const variants = {
  initial: {
    opacity: 0,
    y: "30px",
  },
  enter: {
    opacity: 1,
    y: "0px",
  },
  exit: {
    opacity: 0,
    y: "30px",
  },
};

const MobileMenuIcon = () => {
  const { toggleMenuState, menuOpen } = useSiteContext();

  return (
    <span>
      <div className={styles.menuIcon}>
        <MenuIcon onClick={toggleMenuState} open={menuOpen} />
      </div>
    </span>
  );
};

const Layout: React.FC<PageProps> = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    Analytics.setup();
  }, []);

  const onPageLeft = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        Analytics.pageView();
      });
    });
  }, []);

  return (
    <SiteContainer location={location}>
      <SEO>
        {/* <script
          async
          defer
          data-domain="jthaw.me"
          src="https://plausible.io/js/plausible.js"
        ></script> */}
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@500&display=swap"
          rel="stylesheet"
        />
      </SEO>

      <Header />

      <Navigation />

      <MobileMenuIcon />

      <AnimatePresence
        exitBeforeEnter
        initial={false}
        onExitComplete={onPageLeft}
      >
        <motion.main
          key={location.pathname}
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
          transition={{ duration: 0.75, ease: [0.4, 0, 0.2, 1] }}
          className={styles.main}
        >
          {children}
        </motion.main>
      </AnimatePresence>
    </SiteContainer>
  );
};

export { Layout };
